import {
  ComplexMeasurementUnits,
  FindingSource,
  MeasurementUnits,
} from "fe-common/graphql";
import { unitToSynonyms, WMeasurementUnits } from "@kahunmedical/common-wtypes";

/***
 *
 *   This is a set of functions made to help us deal with
 *   converting types for response
 *
 ***/

export const qualifierValueToQualifierFragment = (
  qualifierValue,
  relation,
  isNumeric = false,
) => ({
  relation,
  name: relation.name,
  value: qualifierValue,
  negate: false,
  // Some qualifier values are declared with a range while this range doesn't
  // represent a user selection but rather an internal configuration. So we usually
  // would clear the range, and send it only in numeric questions, as the rage is
  // constructed by the user itself (like age, fever, lab tests etc - with
  // suggestion type = chooseNumeric)
  range: isNumeric ? qualifierValue?.range : null,
  freeText: qualifierValue.freeText,
  source: FindingSource.Patient,
});

export const MeasurementUnitsToString = (
  units: MeasurementUnits,
  translate = (i) => i,
  limit = null,
  plural = true,
): string => {
  if (!units) return "";
  switch (units) {
    case MeasurementUnits.Hours:
      return translate(plural ? "hours" : "hour");
    case MeasurementUnits.Days:
      return translate(plural ? "days" : "day");
    case MeasurementUnits.Weeks:
      return translate(plural ? "weeks" : "week");
    case MeasurementUnits.Months:
      return translate(plural ? "months" : "month");
    case MeasurementUnits.Years:
      return translate(plural ? "years" : "year");
    case MeasurementUnits.Percent:
      return "%";
    case MeasurementUnits.Celsius:
      return "°C";
    case MeasurementUnits.Fahrenheit:
      return "°F";
    case MeasurementUnits.Pounds:
      return "lb";
    // When we use general units don't add any special text after the value
    case MeasurementUnits.Units:
    case MeasurementUnits.MmHg:
      return "";
    case MeasurementUnits.Inches:
      return translate("in");
    case MeasurementUnits.Feet:
      return translate("ft");
    default:
      return translate(
        unitToSynonyms(((units as unknown) || "") as WMeasurementUnits) ||
          (limit ? units.substr(0, 2) : units),
      );
  }
};

export const ComplexUnitsToString = (
  complexUnits: ComplexMeasurementUnits,
  translate = (i) => i,
) => {
  return (
    complexUnits?.numerator?.map((u) =>
      MeasurementUnitsToString(u, translate),
    ) +
    (!complexUnits?.denominator?.length
      ? ""
      : "/" +
        complexUnits?.denominator?.map((u) =>
          MeasurementUnitsToString(u, translate),
        ))
  );
};
